/*
 * File: d:\projects\AutoFiFront\src\Content\Modals\ModalContact\ModalContact.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday April 19th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 25th April 2023 04:52:33
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { MouseEventHandler } from 'react';
import MyModal from "Content/Modals/MyModal";
import { Contact } from 'Content/Contact/Contact';

type ModalContactProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    themeColor: string,
    category: string,
    energy: string,
    brand: string,
    model: string,
    carId: number,
    mileage: number
};

function ModalContact(props: ModalContactProps) {
    return (
        <React.Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} onClose={props.onClose} addCloseCross={true} footer={(()=>{return (<></>)})()} title={""} className={""} themeColor={props.themeColor}>
                <Contact Category={props.category} Energy={props.energy} Brand={props.brand} Model={props.model} CarId={props.carId} CarTitle={""} Mileage={props.mileage} />
            </MyModal>
        </React.Fragment>
    )
}

export default ModalContact;
